import {Component, EventEmitter, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ArtistService} from '../../../../core/service/artist.service';
import {FormSubmission} from '../../../../model/form-submission';
import * as countries from '../../../../conf/countries';
import {ArtistViewService} from '../artist.view.service';
import {Artist} from '../../../../model/domain/artist';
import {UserService} from '../../../../core/service/user.service';
import {User} from '../../../../model/domain/user';

@Component({
	selector: 'app-artist-edit',
	templateUrl: './artist-edit.component.html',
	styleUrls: ['./artist-edit.component.scss']
})
export class ArtistEditComponent implements OnInit {
	countries = countries.countries;
	artist: Artist = ({} as any) as Artist;
	users: User[] = [];

	result: FormSubmission;
	formState = new EventEmitter<FormSubmission>();

	constructor(
		private route: ActivatedRoute,
		private artistService: ArtistService,
		private artistViewService: ArtistViewService,
		private userService: UserService
	) {
	}

	ngOnInit(): void {
		this.userService.getAll().subscribe(users => this.users = users.filter(user => user.active));
		this.artistViewService.get().subscribe(
			artist => {
				this.artist = JSON.parse(JSON.stringify(artist));
				this.artist.artistType = this.capitalizeFirstLetter(this.artist.artistType);
				this.artist.userId = this.artist.user ? this.artist.user.id : null;
			}
		);
	}

	save(): void {
		this.artistService.updateArtist(this.artist).subscribe(
			form => {
				this.formState.next(form);
				this.result = form;
				if (form.success) {
					this.artistViewService.update(this.result.object);
					this.result.object.artistType = this.capitalizeFirstLetter(form.object.artistType);
				}
			}
		);
	}

	getFieldErrors(name: string): string[] {
		if (!this.result || !this.result.fields) {
			return [];
		}

		const field = this.result.fields.find(value => value.name === name);
		return field ? field.errors : [];
	}

	hasFieldErrors(name: string): boolean {
		return this.getFieldErrors(name).length > 0;
	}

	capitalizeFirstLetter(text: string): string {
		return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
	}
}
